module.exports = __webpack_public_path__ + "img/Evaluate Tests gry (1).af1f06f1.svg";